import React from 'react';
import i18n from '../../../i18n';
import { Field, reduxForm } from 'redux-form';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { useFormError } from 'core/form/form';

import { authResetPasswordPhoneSelector } from 'state/auth/selectors';

import { CodeControlField } from 'components/CodeControl/CodeControl';
import { FormErrorMessage } from 'components/FormErrorMessage/FormErrorMessage';
import { Text, TextTypography } from 'components/Text/Text';

import { Form } from 'forms/types';

const useStyles = makeStyles(theme => ({
    title: {
        marginTop: theme.spacing(3.5),
        marginBottom: theme.spacing(3),
    },
    code: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
    error: {
        marginBottom: theme.spacing(2),
    },
    resend: {
        color: theme.palette.fixedPrimary.lighter,
    },
}));

export const PasswordResetCodeForm = reduxForm({
    form: Form.PASSWORD_RESET_CODE_FORM,
    initialValues: { otp: '' },
})(props => {
    const { handleSubmit } = props;
    const classes = useStyles();
    const { t } = i18n.useTranslation();
    const error = useFormError(Form.PASSWORD_RESET_CODE_FORM);
    const phone = useSelector(authResetPasswordPhoneSelector);
    return (
        <form onSubmit={handleSubmit}>
            <div className={classes.title}>
                <Text typography={TextTypography.DISPLAY_STRONG}>{t('auth:resetPassword.code.title')}</Text>
            </div>
            <div>
                <Text component="div" typography={TextTypography.PARA}>
                    {t('auth:resetPassword.code.descriptionLine1', { phoneNumber: phone })}
                </Text>
                <Text component="div" typography={TextTypography.PARA}>
                    {t('auth:resetPassword.code.descriptionLine2')}
                </Text>
            </div>
            {error && (
                <div className={classes.error}>
                    <FormErrorMessage error={error} />
                </div>
            )}
            <div className={classes.code}>
                <Field name="otp" component={CodeControlField} />
            </div>
        </form>
    );
});
